import { appConfig }  from '../../config';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin,
  jsonHeader,
  postMethod,
  multipartJsonHeader,
}                     from '../fetchTools';

var options = {...defaultOptions, ...jsonHeader};
export const getQMEData = (name, params, param) => {
    console.log("sh get API ")
    console.log(name)
    console.log(params)
    console.log(param)
    if (params == null){
        params="";
    }
    // const url = `${getLocationOrigin(2)}/${appConfig.pcm.data.API}${appConfig.pcm.data[name].path}/${params}`
    const url = `${getLocationOrigin(2)}/${appConfig.pcm.data.API}${appConfig.pcm.data[name].path}/${params}&${param}`
  return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => data)
    .catch(error => error);
};

export const postQMEData = (name, payload) => {
  console.log("sh post API ")
  console.log(name)
  console.log(payload)
  const url = `${getLocationOrigin(2)}/${appConfig.pcm.data.API}${appConfig.pcm.data[name].path}/`
  var options = {...defaultOptions, ...postMethod, ...jsonHeader};
  options.method = 'post';
  options.body = JSON.stringify(payload);
  console.log(options)
  return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(data => data)
      .catch(error => error);
};




// WEBPACK FOOTER //
// ./src/app/services/API/pcm.js